import { Button, Dialog, DialogBody, Typography } from '@material-tailwind/react'
import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

const LoginInfoModal = (props: {
    open: boolean,
    handleClose: any
}) => {

    const { open, handleClose } = props

    const { t } = useTranslation()

    return (
        createPortal(
            <>
                <Dialog open={open} handler={handleClose} className='!min-w-0 !max-w-[640px] bg-white p-[24px] tab:p-[32px] rounded-[16px] '>
                    <DialogBody className="p-0">
                        <div className="flex items-center justify-between mb-[32px]">
                            <Typography variant="lead" className="text-[18px] lap:text-[24px] text-gray-800 font-medium ">
                                {t('loginInfoModal.title')}
                            </Typography>
                        </div>
                        <div className='w-full'>
                            <Typography variant="lead" className="text-[14px] leading-[1.2] lap:text-[20px] text-gray-800 my-[24px] ">
                                {t('loginInfoModal.text1')}
                            </Typography>
                            <Typography variant="lead" className="text-[14px] leading-[1.2] lap:text-[20px] text-gray-800 my-[24px] ">
                                {t('loginInfoModal.text2')}
                            </Typography>
                            <Typography variant="lead" className="text-[14px] leading-[1.2] lap:text-[20px] text-gray-800 my-[24px] ">
                                {t('loginInfoModal.text3')}
                            </Typography>
                            <Button
                                color='white'
                                className='whitespace-nowrap font-normal rounded-full border-2 text-[18px] w-full mt-[16px]'
                                onClick={handleClose}
                            >
                                {t('loginInfoModal.button_text')}
                            </Button>
                        </div>
                    </DialogBody>
                </Dialog>
            </>,
            document.getElementById('root')!
        )
    )
}

export default LoginInfoModal